import React, { Component } from "react";
import _ from "lodash";
import Api from "util/Api";
import WideFacilityCard from "../../components/WideFacilityCard";

class OrganizationShow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            facilities: {},
            orgSummary: {}
        };
    }

    componentDidMount() {
        this._mounted = true;
        const { org } = this.props.match.params;
        Api.withAuth(this.props.auth)
            .getOrganizationSummary(org)
            .then((response) => {
                this.props.auth.onOrganizationDetails(response);
                this.setState({ orgSummary: response });
                if (response.length < 2) {
                    this.props.history.push(`/facilities/${this.props.auth.currentUser.defaultFacility}/sections/${this.props.auth.currentUser.defaultSection}/rooms`);
                }
            });
    }

    render() {
        const { auth } = this.props;
        const { orgSummary } = this.state;
        const section = auth.currentUser.defaultSection;
        let key = 0;
        return (
            <section className="section-index">
                <div className="subnav fixed-top">
                    <div className="container h-100">
                        <div className="row justify-content-end align-items-center h-100">
                            <div className="col-md-2 mr-auto">
                                <strong>All Locations</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="room-cards">
                    {this._mounted &&
                        _.chunk(orgSummary, 3).map((facilityRow, index) => (
                            <div key={key} className="row align-items-stretch">
                                {facilityRow.map((facility) => (
                                    <WideFacilityCard
                                        key={key++}
                                        history={this.props.history}
                                        {...facility}
                                        section={(facility.facility === auth.currentUser.defaultFacility)? auth.currentUser.defaultSection:facility.sections.sectionNames[0]}
                                    />
                                ))}
                            </div>
                        ))
                    }
                </div>
            </section>
        );
    }
}

export default OrganizationShow;
